export enum INTEGRATION_TYPES {
  AEM = 'AEM',
  STANDALONE = 'STANDALONE',
}

export const APP_VERSION = process.env.VUE_APP_VERSION;
export const PLUGIN_ID = process.env.VUE_APP_PLUGIN_ID;

export const SUGGESTION_LOCAL = 'LOCAL';
export const SUGGESTION_LIVE = 'LIVE';

export const DOMAINS = {
  NCOS: 'NCOS',
};
